import { StreamChat } from "stream-chat";
import {useEffect, useState} from "react";

export const useChat = () => {
    const [client, setClient] = useState<StreamChat | null>(null)
    const connect = async () => {
        const chatClient = StreamChat.getInstance("ws6enjueddgr", {
          timeout: 6000,
        });

        const resp = await fetch("/ff/api/chat", { method: "POST" })
        const token = await resp.json().then(body => body.token)
        await chatClient.connectUser(
          {
            id: "tyler",
            name: "Tyler",
            image: "https://getstream.io/random_svg/?name=John",
          },
          token,
        );
        setClient(chatClient)
    }

    useEffect(() => {
        connect().catch(console.error)
    }, [])
    return client
}